import { ErrorHandler, Injectable } from "@angular/core";

/**
 * Handles chunk load errors caused by stale index.html after a new deployment.
 * When Angular lazy-loads a route, it fetches a JS chunk by hash. If a new
 * deployment has replaced those chunks, the browser gets a 404. This handler
 * catches that scenario and forces a full page reload to get the fresh bundle.
 */
@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);

    const isChunkLoadError =
      message.includes("Failed to fetch dynamically imported module") ||
      message.includes("Loading chunk") ||
      message.includes("ChunkLoadError");

    if (isChunkLoadError) {
      window.location.reload();
    } else {
      console.error(error);
    }
  }
}
